import { axiosInstance } from '@config/axios/axios.config.ts';
import { paths } from '@types';
import { useQuery } from '@tanstack/react-query';

const activitiesMetricsTodayRequest = async () => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const response = axiosInstance.get<
    paths[`/activities/metrics/today`]['get']['responses']['200']['content']['application/json']
  >(`/activities/metrics/today`, {
    params: {
      timezone,
    },
  });
  const data = (await response).data;

  return data;
};

export const useActivitiesMetricsTodayQuery = () => {
  const query = useQuery({
    queryKey: ['activityLog', 'metrics', 'today'],
    queryFn: () => activitiesMetricsTodayRequest(),
  });

  return query;
};
